import { css } from '@emotion/react';
import NvTooltip from 'shared/components/nv-tooltip';

type ScaleScore = {
  score: number;
  color: string;
  text: string;
};

const styles = css`
  .scale {
    height: 25px;
  }
`;

const SCALE_MIN_WIDTH = 30;
const SCALE_MULTIPLIER = 3;

const ScaleBar = ({ scores }: { scores: ScaleScore[] }) => {
  let maxScoreIndex = 0;
  scores.forEach((score, index) => {
    if (score.score > scores[maxScoreIndex].score) {
      maxScoreIndex = index;
    }
  });
  return (
    <div css={styles}>
      <div className='d-flex text-black font-weight-bold text-small'>
        {scores.map((score, index) => (
          score.score > 0 && (
            <NvTooltip
              key={index.toString()}
              text={score.text}
              placement='top'
            >
              <div
                key={index.toString()}
                style={{ backgroundColor: score.color, ...(index === maxScoreIndex ? { flex: 1 } : { minWidth: SCALE_MIN_WIDTH + (score.score * SCALE_MULTIPLIER), width: `${score.score}%` }) }}
                className='scale d-flex align-items-center justify-content-center'
              >
                {score.score}%
              </div>
            </NvTooltip>
          )
        ))}
      </div>
    </div>
  );
};

export default ScaleBar;
